import { DateTime } from 'luxon';

export const formatUTCToLocal = (utcString) => {
  return DateTime.fromISO(utcString, { zone: 'utc' })
    .toLocal()
    .toFormat('yyyy-MM-dd, hh:mm a');
};
